export default __webpack_public_path__ + "static/media/hero-level-2-chars-desk.69ea94e5.webp";